import { render } from "./FloatWhatsapp.vue?vue&type=template&id=6442a1d0&scoped=true"
import script from "./FloatWhatsapp.vue?vue&type=script&lang=js"
export * from "./FloatWhatsapp.vue?vue&type=script&lang=js"

import "./FloatWhatsapp.vue?vue&type=style&index=0&id=6442a1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6442a1d0"]])

export default __exports__